import {HttpErrorResponse} from '@angular/common/http';
import {ERROR} from '../Errors';
import {SimpleModalType} from '~shared/types/dialog.types';

export const SOMETHING_WRONG = 'Oopps something went wrong!';

export function errorHandler(error: HttpErrorResponse) {
    if ('errors' in error.error) {
        const expectedError = ERROR[error.error?.errors[0]?.error.toUpperCase()];
        this.dialogService.createSimple(
            {
                type: SimpleModalType.ERROR,
                title: expectedError?.title ?? '',
                content: expectedError?.message ?? error.error?.errors[0]?.error,
            });
    } else {
        this.dialogService.createSimple(
            {
                type: SimpleModalType.ERROR,
                content: SOMETHING_WRONG,
            });
    }
}
